import React from 'react';
import { BookOpen, Lock, CheckCircle, FileText, Download } from 'lucide-react';
import { toast } from 'sonner';
import { getActivityProgress } from '../../utils/progressTracker';
import { ActivityProgressBar, ProgressBadge } from '../ProgressComponents';

const CoursesTab = ({
  subscriptionInfo, user, selectedProgramId, enrolledProgram,
  userCourses, getCourseProgress, handleCourseClick
}) => {
  return (
          <div>
            {subscriptionInfo?.expired && user.role !== 'admin' ? (
              <div className="card" style={{
                padding: '2rem',
                textAlign: 'center',
                background: '#FEF2F2',
                border: '2px solid #fca5a5',
                borderRadius: '1rem'
              }}>
                <Lock size={40} style={{ color: '#DC2626', marginBottom: '1rem' }} />
                <h3 style={{ fontWeight: 700, fontSize: '1.1rem', color: '#DC2626', marginBottom: '0.5rem' }}>
                  Accès expiré
                </h3>
                <p style={{ color: '#6B7280', marginBottom: '1rem' }}>
                  Votre accès d'un an à la plateforme est arrivé à terme. Contactez-nous pour renouveler votre abonnement.
                </p>
                <a href="mailto:apdr.vae@gmail.com" className="btn-primary" style={{ display: 'inline-flex' }}>
                  Contactez-nous
                </a>
              </div>
            ) : (
            <div>
            <h2 className="heading-1" style={{ marginBottom: '2rem' }}>
              Tous les cours - {enrolledProgram?.title}
            </h2>
            
            {/* Group courses by bloc for DEAP */}
            {selectedProgramId === 'deap' ? (
              <>
                {/* Introduction course - displayed first */}
                {userCourses.filter(c => !c.isHeader && !c.blocId).map((course) => {
                  const courseProgress = getCourseProgress(course);
                  return (
                    <div key={course.id} className="card hover-lift" data-testid="deap-intro-course" style={{
                      cursor: 'pointer', marginBottom: '2rem',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white', padding: '0', overflow: 'hidden', borderRadius: '1rem'
                    }} onClick={() => handleCourseClick(course)}>
                      {course.thumbnail && (
                        <img src={course.thumbnail} alt={course.title} style={{
                          width: '100%', height: '200px', objectFit: 'cover'
                        }} />
                      )}
                      <div style={{ padding: '1.5rem', display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{
                          background: 'rgba(255,255,255,0.2)', borderRadius: '1rem',
                          width: '60px', height: '60px',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                        }}>
                          <BookOpen size={32} color="white" />
                        </div>
                        <div style={{ flex: 1, minWidth: '200px' }}>
                          <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>{course.title}</h3>
                          <p style={{ opacity: 0.9, fontSize: '0.9rem' }}>{course.description}</p>
                          {course.slideCount && <span style={{ opacity: 0.8, fontSize: '0.8rem' }}>{course.slideCount} slides · {course.duration || 'Présentation interactive'}</span>}
                        </div>
                        {courseProgress && (
                          <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem', padding: '0.5rem 1rem' }}>
                            <ProgressBadge progress={courseProgress} />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* Bloc 1 Container */}
                {userCourses.some(c => c.blocId === 'bloc1') && (
                  <div style={{ 
                    marginBottom: '2rem',
                    border: '3px solid #E75480',
                    borderRadius: '1.5rem',
                    overflow: 'hidden',
                    background: 'white'
                  }}>
                    {/* Bloc 1 Header */}
                    <div style={{
                      background: 'linear-gradient(135deg, #E75480 0%, #FF6B9D 100%)',
                      padding: '1.5rem 2rem'
                    }}>
                      <h3 className="heading-2" style={{ color: 'white', marginBottom: '0.5rem', fontSize: '1.3rem' }}>
                        BLOC 1 - Accompagnement et soins de l'enfant dans les activités de la vie quotidienne et de la vie sociale
                      </h3>
                    </div>
                    
                    {/* Activities inside Bloc 1 */}
                    <div style={{ 
                      padding: '1.5rem',
                      background: 'linear-gradient(180deg, #FFF5F7 0%, #FFFFFF 100%)'
                    }}>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem' }}>
                        {userCourses.filter(c => c.blocId === 'bloc1' && !c.isHeader).map((course) => {
                          const courseProgress = getCourseProgress(course);
                          return (
                          <div
                            key={course.id}
                            className={`card hover-lift`}
                            style={{ 
                              cursor: course.locked || course.comingSoon ? 'not-allowed' : 'pointer',
                              opacity: course.locked ? 0.7 : 1,
                              display: 'flex',
                              flexDirection: 'column',
                              position: 'relative',
                              border: '1px solid #E7548020',
                              boxShadow: '0 4px 12px rgba(231, 84, 128, 0.1)'
                            }}
                            onClick={() => !course.comingSoon && handleCourseClick(course)}
                          >
                            {course.comingSoon && (
                              <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#F59E0B',
                                color: 'white',
                                padding: '0.25rem 0.75rem',
                                borderRadius: '1rem',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                zIndex: 1
                              }}>
                                Bientôt disponible
                              </div>
                            )}
                            {/* Progress Badge */}
                            {courseProgress && (
                              <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                                <ProgressBadge progress={courseProgress} />
                              </div>
                            )}
                            {course.thumbnail && (
                              <img
                                src={course.thumbnail}
                                alt={course.title}
                                style={{
                                  width: '100%',
                                  height: '140px',
                                  objectFit: 'cover',
                                  borderRadius: '0.5rem',
                                  marginBottom: '1rem'
                                }}
                              />
                            )}
                            <div style={{
                              background: course.locked ? 'var(--bg-section)' : '#E7548020',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '1rem',
                              width: 'fit-content',
                              marginBottom: '0.75rem'
                            }}>
                              <span className="caption font-mono" style={{ textTransform: 'uppercase', color: '#E75480' }}>
                                {course.type}
                              </span>
                            </div>
                            <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                              {course.title}
                            </h3>
                            <p className="body-small" style={{ marginBottom: '0.5rem', flex: 1, fontSize: '0.85rem' }}>
                              {course.description}
                            </p>
                            {/* Progress Bar */}
                            {courseProgress && (
                              <div style={{ marginBottom: '0.75rem' }}>
                                <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                              </div>
                            )}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                              {course.locked && <Lock size={16} />}
                              {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                            </div>
                          </div>
                        )})}
                      </div>
                    </div>
                  </div>
                )}

                {/* Bloc 2 Container */}
                {userCourses.some(c => c.blocId === 'bloc2') && (
                  <div style={{ 
                    marginBottom: '2rem',
                    border: '3px solid #3B82F6',
                    borderRadius: '1.5rem',
                    overflow: 'hidden',
                    background: 'white'
                  }}>
                    {/* Bloc 2 Header */}
                    <div style={{
                      background: 'linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)',
                      padding: '1.5rem 2rem'
                    }}>
                      <h3 className="heading-2" style={{ color: 'white', marginBottom: '0.5rem', fontSize: '1.1rem' }}>
                        BLOC 2 - Appréciation de l'état clinique de la personne et mise en œuvre de soins adaptés en collaboration avec l'infirmier en intégrant la qualité et la prévention des risques
                      </h3>
                    </div>
                    
                    {/* Activities inside Bloc 2 */}
                    <div style={{ 
                      padding: '1.5rem',
                      background: 'linear-gradient(180deg, #EFF6FF 0%, #FFFFFF 100%)'
                    }}>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem' }}>
                        {userCourses.filter(c => c.blocId === 'bloc2' && !c.isHeader).map((course) => {
                          const courseProgress = getCourseProgress(course);
                          return (
                          <div
                            key={course.id}
                            className={`card hover-lift`}
                            style={{ 
                              cursor: course.locked || course.comingSoon ? 'not-allowed' : 'pointer',
                              opacity: course.comingSoon ? 0.85 : course.locked ? 0.7 : 1,
                              display: 'flex',
                              flexDirection: 'column',
                              position: 'relative',
                              border: '1px solid #3B82F620',
                              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)'
                            }}
                            onClick={() => !course.comingSoon && handleCourseClick(course)}
                          >
                            {course.comingSoon && (
                              <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#F59E0B',
                                color: 'white',
                                padding: '0.25rem 0.75rem',
                                borderRadius: '1rem',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                zIndex: 1
                              }}>
                                En attente du contenu
                              </div>
                            )}
                            {/* Progress Badge */}
                            {courseProgress && (
                              <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                                <ProgressBadge progress={courseProgress} />
                              </div>
                            )}
                            {course.thumbnail && (
                              <img
                                src={course.thumbnail}
                                alt={course.title}
                                style={{
                                  width: '100%',
                                  height: '140px',
                                  objectFit: 'cover',
                                  borderRadius: '0.5rem',
                                  marginBottom: '1rem',
                                  filter: course.comingSoon ? 'grayscale(30%)' : 'none'
                                }}
                              />
                            )}
                            <div style={{
                              background: course.locked ? 'var(--bg-section)' : '#3B82F620',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '1rem',
                              width: 'fit-content',
                              marginBottom: '0.75rem'
                            }}>
                              <span className="caption font-mono" style={{ textTransform: 'uppercase', color: '#3B82F6' }}>
                                {course.type}
                              </span>
                            </div>
                            <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                              {course.title}
                            </h3>
                            <p className="body-small" style={{ marginBottom: '0.5rem', flex: 1, fontSize: '0.85rem' }}>
                              {course.description}
                            </p>
                            {/* Progress Bar */}
                            {courseProgress && (
                              <div style={{ marginBottom: '0.75rem' }}>
                                <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                              </div>
                            )}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                              {course.locked && <Lock size={16} />}
                              {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                            </div>
                          </div>
                        )})}
                      </div>
                    </div>
                  </div>
                )}

                {/* BLOC 3 - Information et accompagnement */}
                {userCourses.some(c => c.blocId === 'bloc3') && (
                  <div style={{ marginTop: '2rem' }}>
                    <div style={{ 
                      background: 'linear-gradient(135deg, #EC4899 0%, #DB2777 100%)',
                      borderRadius: '1rem',
                      padding: '1.5rem',
                      marginBottom: '1.5rem'
                    }}>
                      <h3 className="heading-2" style={{ color: 'white', marginBottom: '0.5rem' }}>
                        BLOC 3 - Information et accompagnement des personnes et de leur entourage, des professionnels et des apprenants
                      </h3>
                      <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                        Information et accompagnement des personnes et de leur entourage, des professionnels et des apprenants
                      </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                      {userCourses.filter(c => c.blocId === 'bloc3' && !c.isHeader).map((course) => {
                        const courseProgress = getCourseProgress(course);
                        return (
                        <div
                          key={course.id}
                          className={`card hover-lift`}
                          style={{ 
                            cursor: course.locked || course.comingSoon ? 'not-allowed' : 'pointer',
                            opacity: course.comingSoon ? 0.85 : course.locked ? 0.7 : 1,
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            border: '1px solid #EC489920',
                            boxShadow: '0 4px 12px rgba(236, 72, 153, 0.1)'
                          }}
                          onClick={() => !course.comingSoon && handleCourseClick(course)}
                        >
                          {course.comingSoon && (
                            <div style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              background: '#F59E0B',
                              color: 'white',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '1rem',
                              fontSize: '0.75rem',
                              fontWeight: '600',
                              zIndex: 1
                            }}>
                              En attente du contenu
                            </div>
                          )}
                          {/* Progress Badge */}
                          {courseProgress && (
                            <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                              <ProgressBadge progress={courseProgress} />
                            </div>
                          )}
                          {course.thumbnail && (
                            <img
                              src={course.thumbnail}
                              alt={course.title}
                              style={{
                                width: '100%',
                                height: '140px',
                                objectFit: 'cover',
                                borderRadius: '0.5rem',
                                marginBottom: '1rem',
                                filter: course.comingSoon ? 'grayscale(30%)' : 'none'
                              }}
                            />
                          )}
                          <div style={{
                            background: course.locked ? 'var(--bg-section)' : '#EC489920',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '1rem',
                            width: 'fit-content',
                            marginBottom: '0.75rem'
                          }}>
                            <span className="caption font-mono" style={{ textTransform: 'uppercase', color: '#EC4899' }}>
                              {course.type}
                            </span>
                          </div>
                          <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                            {course.title}
                          </h3>
                          <p className="body-small" style={{ marginBottom: '0.5rem', flex: 1, fontSize: '0.85rem' }}>
                            {course.description}
                          </p>
                          {/* Progress Bar */}
                          {courseProgress && (
                            <div style={{ marginBottom: '0.75rem' }}>
                              <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                            </div>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {course.locked && <Lock size={16} />}
                            {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                          </div>
                        </div>
                      )})}
                    </div>
                  </div>
                )}

                {/* BLOC 4 - Entretien de l'environnement */}
                {userCourses.some(c => c.blocId === 'bloc4') && (
                  <div style={{ marginTop: '2rem' }}>
                    <div style={{ 
                      background: 'linear-gradient(135deg, #059669 0%, #10B981 100%)',
                      borderRadius: '1rem',
                      padding: '1.5rem',
                      marginBottom: '1.5rem'
                    }}>
                      <h3 className="heading-2" style={{ color: 'white', marginBottom: '0.5rem' }}>
                        BLOC 4 - Entretien de l'environnement immédiat de la personne et des matériels
                      </h3>
                      <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                        Entretien des locaux et matériels liés aux activités de soins, au lieu et aux situations d'intervention
                      </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                      {userCourses.filter(c => c.blocId === 'bloc4' && !c.isHeader).map((course) => {
                        const courseProgress = getCourseProgress(course);
                        return (
                        <div
                          key={course.id}
                          className={`card hover-lift`}
                          style={{ 
                            cursor: course.locked || course.comingSoon ? 'not-allowed' : 'pointer',
                            opacity: course.comingSoon ? 0.85 : course.locked ? 0.7 : 1,
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            border: '1px solid #05966920',
                            boxShadow: '0 4px 12px rgba(5, 150, 105, 0.1)'
                          }}
                          onClick={() => !course.comingSoon && handleCourseClick(course)}
                        >
                          {course.comingSoon && (
                            <div style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              background: '#F59E0B',
                              color: 'white',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '1rem',
                              fontSize: '0.75rem',
                              fontWeight: '600',
                              zIndex: 1
                            }}>
                              En attente du contenu
                            </div>
                          )}
                          {/* Progress Badge */}
                          {courseProgress && (
                            <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                              <ProgressBadge progress={courseProgress} />
                            </div>
                          )}
                          {course.thumbnail && (
                            <img
                              src={course.thumbnail}
                              alt={course.title}
                              style={{
                                width: '100%',
                                height: '140px',
                                objectFit: 'cover',
                                borderRadius: '0.5rem',
                                marginBottom: '1rem',
                                filter: course.comingSoon ? 'grayscale(30%)' : 'none'
                              }}
                            />
                          )}
                          <div style={{
                            background: course.locked ? 'var(--bg-section)' : '#05966920',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '1rem',
                            width: 'fit-content',
                            marginBottom: '0.75rem'
                          }}>
                            <span className="caption font-mono" style={{ textTransform: 'uppercase', color: '#059669' }}>
                              {course.type}
                            </span>
                          </div>
                          <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                            {course.title}
                          </h3>
                          <p className="body-small" style={{ marginBottom: '0.5rem', flex: 1, fontSize: '0.85rem' }}>
                            {course.description}
                          </p>
                          {/* Progress Bar */}
                          {courseProgress && (
                            <div style={{ marginBottom: '0.75rem' }}>
                              <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                            </div>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {course.locked && <Lock size={16} />}
                            {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                          </div>
                        </div>
                      )})}
                    </div>
                  </div>
                )}

                {/* BLOC 5 - Transmission et organisation */}
                {userCourses.some(c => c.blocId === 'bloc5') && (
                  <div style={{ marginTop: '2rem' }}>
                    <div style={{ 
                      background: 'linear-gradient(135deg, #0891B2 0%, #06B6D4 100%)',
                      borderRadius: '1rem',
                      padding: '1.5rem',
                      marginBottom: '1.5rem'
                    }}>
                      <h3 className="heading-2" style={{ color: 'white', marginBottom: '0.5rem' }}>
                        BLOC 5 - Transmission des observations pour la continuité des soins
                      </h3>
                      <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                        Transmission, quels que soient l'outil et les modalités de communication, des observations recueillies pour maintenir la continuité des soins et des activités
                      </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                      {userCourses.filter(c => c.blocId === 'bloc5' && !c.isHeader).map((course) => {
                        const courseProgress = getCourseProgress(course);
                        return (
                        <div
                          key={course.id}
                          className={`card hover-lift`}
                          style={{ 
                            cursor: course.locked || course.comingSoon ? 'not-allowed' : 'pointer',
                            opacity: course.comingSoon ? 0.85 : course.locked ? 0.7 : 1,
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            border: '1px solid #0891B220',
                            boxShadow: '0 4px 12px rgba(8, 145, 178, 0.1)'
                          }}
                          onClick={() => !course.comingSoon && handleCourseClick(course)}
                        >
                          {course.comingSoon && (
                            <div style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              background: '#F59E0B',
                              color: 'white',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '1rem',
                              fontSize: '0.75rem',
                              fontWeight: '600',
                              zIndex: 1
                            }}>
                              En attente du contenu
                            </div>
                          )}
                          {/* Progress Badge */}
                          {courseProgress && (
                            <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1 }}>
                              <ProgressBadge progress={courseProgress} />
                            </div>
                          )}
                          {course.thumbnail && (
                            <img
                              src={course.thumbnail}
                              alt={course.title}
                              style={{
                                width: '100%',
                                height: '140px',
                                objectFit: 'cover',
                                borderRadius: '0.5rem',
                                marginBottom: '1rem',
                                filter: course.comingSoon ? 'grayscale(30%)' : 'none'
                              }}
                            />
                          )}
                          <div style={{
                            background: course.locked ? 'var(--bg-section)' : '#0891B220',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '1rem',
                            width: 'fit-content',
                            marginBottom: '0.75rem'
                          }}>
                            <span className="caption font-mono" style={{ textTransform: 'uppercase', color: '#0891B2' }}>
                              {course.type}
                            </span>
                          </div>
                          <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                            {course.title}
                          </h3>
                          <p className="body-small" style={{ marginBottom: '0.5rem', flex: 1, fontSize: '0.85rem' }}>
                            {course.description}
                          </p>
                          {/* Progress Bar */}
                          {courseProgress && (
                            <div style={{ marginBottom: '0.75rem' }}>
                              <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                            </div>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {course.locked && <Lock size={16} />}
                            {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                          </div>
                        </div>
                      )})}
                    </div>
                  </div>
                )}
                
              </>
            ) : selectedProgramId === 'bac-assp' ? (
              /* BAC ASSP - Group courses by Bloc */
              <>
                {/* Livret 2 BAC ASSP Annoté - Download Banner */}
                <div 
                  className="card hover-lift"
                  style={{ 
                    marginBottom: '2rem',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '1.5rem'
                  }}
                  data-testid="livret2-bac-assp-download"
                >
                  <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '1rem',
                      width: '70px',
                      height: '70px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <FileText size={35} />
                    </div>
                    <div style={{ flex: 1, minWidth: '200px' }}>
                      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                        Livret 2 BAC ASSP Annoté
                      </h2>
                      <p style={{ opacity: 0.9, marginBottom: '0' }}>
                        Téléchargez votre modèle de Livret 2 avec annotations et conseils de rédaction.
                      </p>
                    </div>
                    <a
                      href="/downloads/bac-assp/livret2-bac-assp-annote.pdf"
                      download="Livret2-BAC-ASSP-Annote.pdf"
                      className="btn-primary"
                      style={{
                        background: 'white',
                        color: '#667eea',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '0.5rem',
                        textDecoration: 'none',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toast.success('Téléchargement du Livret 2 en cours...');
                      }}
                    >
                      <Download size={20} />
                      Télécharger
                    </a>
                  </div>
                </div>

                {/* Introduction course */}
                {userCourses.filter(c => !c.isHeader && !c.blocId).map((course) => {
                  const courseProgress = getCourseProgress(course);
                  return (
                    <div key={course.id} className="card hover-lift" data-testid="bac-assp-intro-course" style={{
                      cursor: 'pointer', marginBottom: '2rem',
                      background: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
                      color: 'white', padding: '0', overflow: 'hidden', borderRadius: '1rem'
                    }} onClick={() => handleCourseClick(course)}>
                      {course.thumbnail && (
                        <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                      )}
                      <div style={{ padding: '1.5rem', display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{
                          background: 'rgba(255,255,255,0.2)', borderRadius: '1rem',
                          width: '60px', height: '60px',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                        }}>
                          <BookOpen size={32} color="white" />
                        </div>
                        <div style={{ flex: 1, minWidth: '200px' }}>
                          <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>{course.title}</h3>
                          <p style={{ opacity: 0.9, fontSize: '0.9rem' }}>{course.description}</p>
                        </div>
                        {courseProgress && (
                          <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem', padding: '0.5rem 1rem' }}>
                            <ProgressBadge progress={courseProgress} />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* Bloc sections */}
                {['bloc1', 'bloc2', 'bloc3', 'bloc4', 'pse', 'outils'].map((blocId) => {
                  const header = userCourses.find(c => c.isHeader && c.blocId === blocId);
                  const items = userCourses.filter(c => !c.isHeader && c.blocId === blocId);
                  if (!header || items.length === 0) return null;
                  const color = header.color || '#7C3AED';
                  return (
                    <div key={blocId} data-testid={`bac-assp-${blocId}-section`} style={{
                      marginBottom: '2rem', border: `2px solid ${color}`,
                      borderRadius: '1rem', overflow: 'hidden', background: 'white'
                    }}>
                      {/* Bloc Header */}
                      <div style={{
                        background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
                        padding: '1.25rem 1.5rem', color: 'white'
                      }}>
                        <h3 style={{ fontWeight: 'bold', fontSize: '1.3rem', marginBottom: '0.5rem' }}>
                          {header.title}
                        </h3>
                        {(() => {
                          const presCourse = items.find(c => c.type === 'presentation');
                          const quizCourse = items.find(c => c.type === 'quiz');
                          const presProgress = presCourse ? getActivityProgress(presCourse.presentationType) : null;
                          const quizProgress = quizCourse ? getActivityProgress(quizCourse.presentationType) : null;
                          const presPercent = presProgress && presProgress.totalSlides ? Math.round((presProgress.viewedSlides.length / presProgress.totalSlides) * 100) : 0;
                          const quizDone = quizProgress && quizProgress.quizCompleted;
                          const globalPercent = Math.round((presPercent * 0.7 + (quizDone ? 100 : 0) * 0.3));
                          return (
                            <div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', opacity: 0.9, marginBottom: '0.25rem' }}>
                                <span>Progression : {globalPercent}%</span>
                                <span>Cours : {presPercent}% | Quiz : {quizDone ? 'Validé' : 'À faire'}</span>
                              </div>
                              <div style={{ height: '6px', background: 'rgba(255,255,255,0.3)', borderRadius: '3px', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: `${globalPercent}%`, background: 'white', borderRadius: '3px', transition: 'width 0.5s ease' }} />
                              </div>
                            </div>
                          );
                        })()}
                      </div>

                      {/* Courses inside bloc - DEEJE style */}
                      <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        {items.map((course) => {
                          const courseProgress = getActivityProgress(course.presentationType);
                          return (
                            <div
                              key={course.id}
                              className="card hover-lift"
                              data-testid={`bac-assp-course-${course.id}`}
                              style={{
                                cursor: course.locked ? 'not-allowed' : 'pointer',
                                opacity: course.locked ? 0.7 : 1,
                                margin: 0, borderLeft: `3px solid ${color}`, padding: '1.25rem'
                              }}
                              onClick={() => handleCourseClick(course)}
                            >
                              {course.thumbnail && (
                                <img src={course.thumbnail} alt={course.title} style={{
                                  width: '100%', height: '180px', objectFit: 'cover',
                                  borderRadius: '0.75rem', marginBottom: '1rem'
                                }} />
                              )}
                              <div style={{
                                background: `${color}20`, padding: '0.3rem 0.75rem',
                                borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem'
                              }}>
                                <span className="caption font-mono" style={{ textTransform: 'uppercase', color: color, fontWeight: '600' }}>
                                  {course.type === 'quiz' ? `QUIZ · ${course.questions || 20} questions` : `PRÉSENTATION`}
                                </span>
                              </div>
                              <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
                                {course.title}
                              </h3>
                              <p className="body-small" style={{ marginBottom: '1rem', color: '#666', lineHeight: '1.5' }}>
                                {course.description}
                              </p>
                              {course.id === 'bac-assp-bloc1' && course.type === 'presentation' && (
                                <img
                                  src="https://customer-assets.emergentagent.com/job_7ebc9951-ac6a-45ad-bbd9-5b722966c82a/artifacts/pk0wcmbu_image.png"
                                  alt="Accompagner la personne"
                                  data-testid="bac-assp-bloc1-illustration"
                                  style={{
                                    width: '100%', maxHeight: '180px', objectFit: 'cover',
                                    borderRadius: '0.75rem', marginBottom: '1rem'
                                  }}
                                />
                              )}
                              {course.id === 'bac-assp-bloc2' && course.type === 'presentation' && (
                                <img
                                  src="https://customer-assets.emergentagent.com/job_7ebc9951-ac6a-45ad-bbd9-5b722966c82a/artifacts/h690uaei_image.png"
                                  alt="Soins d'hygiène, de confort et sécurité"
                                  data-testid="bac-assp-bloc2-illustration"
                                  style={{
                                    width: '100%', maxHeight: '180px', objectFit: 'cover',
                                    borderRadius: '0.75rem', marginBottom: '1rem'
                                  }}
                                />
                              )}
                              {course.id === 'bac-assp-bloc3' && course.type === 'presentation' && (
                                <img
                                  src="https://customer-assets.emergentagent.com/job_7ebc9951-ac6a-45ad-bbd9-5b722966c82a/artifacts/7x6nzzwq_image.png"
                                  alt="Travailler et communiquer en équipe"
                                  data-testid="bac-assp-bloc3-illustration"
                                  style={{
                                    width: '100%', maxHeight: '180px', objectFit: 'cover',
                                    borderRadius: '0.75rem', marginBottom: '1rem'
                                  }}
                                />
                              )}
                              {course.id === 'bac-assp-bloc4' && course.type === 'presentation' && (
                                <img
                                  src="https://customer-assets.emergentagent.com/job_7ebc9951-ac6a-45ad-bbd9-5b722966c82a/artifacts/h0iupoy2_image.png"
                                  alt="Éducation à la santé"
                                  data-testid="bac-assp-bloc4-illustration"
                                  style={{
                                    width: '100%', maxHeight: '180px', objectFit: 'cover',
                                    borderRadius: '0.75rem', marginBottom: '1rem'
                                  }}
                                />
                              )}
                              {course.type === 'quiz' && ['bloc1', 'bloc2', 'bloc3', 'bloc4'].includes(blocId) && (
                                <img
                                  src="https://customer-assets.emergentagent.com/job_7ebc9951-ac6a-45ad-bbd9-5b722966c82a/artifacts/miweldot_image.png"
                                  alt="Quiz"
                                  data-testid={`bac-assp-${blocId}-quiz-illustration`}
                                  style={{
                                    width: '100%', maxHeight: '180px', objectFit: 'cover',
                                    borderRadius: '0.75rem', marginBottom: '1rem'
                                  }}
                                />
                              )}
                              {courseProgress && (
                                <div style={{ marginBottom: '0.5rem' }}>
                                  <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                                </div>
                              )}
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                {course.locked && <Lock size={16} />}
                                {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : selectedProgramId === 'deeje' ? (
              /* DEEJE - Group courses by DC */
              <>
                {/* Introduction course */}
                {userCourses.filter(c => !c.isHeader && !c.dcId).length > 0 && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
                    {userCourses.filter(c => !c.isHeader && !c.dcId).map((course) => (
                      <div key={course.id} className="card hover-lift" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column' }} onClick={() => handleCourseClick(course)}>
                        {course.thumbnail && <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '0.5rem', marginBottom: '1rem' }} />}
                        <div style={{ background: 'var(--accent-blue-200)', padding: '0.25rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                          <span className="caption font-mono" style={{ textTransform: 'uppercase' }}>{course.type}</span>
                        </div>
                        <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>{course.title}</h3>
                        <p className="body-small" style={{ marginBottom: '1rem', flex: 1 }}>{course.description}</p>
                      </div>
                    ))}
                  </div>
                )}

                {/* DC sections with blocs inside */}
                {['pedagogues', 'glossaire', 'lois', 'dc1', 'dc2', 'dc3', 'dc4'].map((dcId) => {
                  const header = userCourses.find(c => c.isHeader && c.dcId === dcId);
                  const blocs = userCourses.filter(c => !c.isHeader && c.dcId === dcId);
                  if (!header || blocs.length === 0) return null;
                  return (
                    <div key={dcId} data-testid={`deeje-${dcId}-section`} style={{ marginBottom: '2rem', border: `2px solid ${header.color}`, borderRadius: '1rem', overflow: 'hidden', background: 'white' }}>
                      <div style={{ background: `linear-gradient(135deg, ${header.color} 0%, ${header.color}CC 100%)`, padding: '1.25rem 1.5rem', color: 'white' }}>
                        <h3 style={{ fontWeight: 'bold', fontSize: '1.3rem', marginBottom: '0.5rem' }}>{header.title}</h3>
                        {(() => {
                          const presCourse = blocs.find(c => c.type === 'presentation');
                          const quizCourse = blocs.find(c => c.type === 'quiz');
                          const presProgress = presCourse ? getActivityProgress(presCourse.presentationType) : null;
                          const quizProgress = quizCourse ? getActivityProgress(quizCourse.presentationType) : null;
                          const presPercent = presProgress && presProgress.totalSlides ? Math.round((presProgress.viewedSlides.length / presProgress.totalSlides) * 100) : 0;
                          const quizDone = quizProgress && quizProgress.quizCompleted;
                          const globalPercent = Math.round((presPercent * 0.7 + (quizDone ? 100 : 0) * 0.3));
                          return (
                            <div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', opacity: 0.9, marginBottom: '0.25rem' }}>
                                <span>Progression : {globalPercent}%</span>
                                <span>Cours : {presPercent}% | Quiz : {quizDone ? 'Valide' : 'A faire'}</span>
                              </div>
                              <div style={{ height: '6px', background: 'rgba(255,255,255,0.3)', borderRadius: '3px', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: `${globalPercent}%`, background: 'white', borderRadius: '3px', transition: 'width 0.5s ease' }} />
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                      <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        {blocs.map((course) => {
                          const courseProgress = getActivityProgress(course.presentationType);
                          return (
                            <div key={course.id} className="card hover-lift" data-testid={`deeje-course-${course.blocId}`} style={{ cursor: course.locked ? 'not-allowed' : 'pointer', opacity: course.locked ? 0.7 : 1, margin: 0, borderLeft: `3px solid ${header.color}`, padding: '1.25rem' }} onClick={() => handleCourseClick(course)}>
                              {course.thumbnail && <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem' }} />}
                              <div style={{ background: `${header.color}20`, padding: '0.3rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                                <span className="caption font-mono" style={{ textTransform: 'uppercase', color: header.color, fontWeight: '600' }}>{course.type === 'quiz' ? `${course.type} - ${course.questionCount} questions` : `${course.type} - ${course.slideCount} slides`}</span>
                              </div>
                              <p className="body-small" style={{ marginBottom: '0.5rem', color: header.color, fontWeight: '500', whiteSpace: 'pre-line' }}>{header.description}</p>
                              <p className="body-small" style={{ marginBottom: '1rem', color: '#666', lineHeight: '1.5' }}>{course.description}</p>
                              {courseProgress && (
                                <div style={{ marginBottom: '0.5rem' }}>
                                  <ActivityProgressBar activityId={course.presentationType} progress={courseProgress} showDetails={true} />
                                </div>
                              )}
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                {course.locked && <Lock size={16} />}
                                {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : selectedProgramId === 'tp' ? (
              /* TP IEPE - Group courses by bloc, like DEEJE layout */
              <>
                {/* Introduction course */}
                {userCourses.filter(c => !c.isHeader && !c.blocId).length > 0 && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
                    {userCourses.filter(c => !c.isHeader && !c.blocId).map((course) => (
                      <div key={course.id} className="card hover-lift" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column' }} onClick={() => handleCourseClick(course)}>
                        {course.thumbnail && <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '0.5rem', marginBottom: '1rem' }} />}
                        <div style={{ background: 'var(--accent-blue-200)', padding: '0.25rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                          <span className="caption font-mono" style={{ textTransform: 'uppercase' }}>{course.type}</span>
                        </div>
                        <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>{course.title}</h3>
                        <p className="body-small" style={{ marginBottom: '1rem', flex: 1 }}>{course.description}</p>
                      </div>
                    ))}
                  </div>
                )}

                {/* Bloc sections */}
                {['bloc1', 'bloc2', 'bloc3'].map((blocId) => {
                  const header = userCourses.find(c => c.isHeader && c.blocId === blocId);
                  const blocCourses = userCourses.filter(c => !c.isHeader && c.blocId === blocId);
                  if (!header || blocCourses.length === 0) return null;
                  const blocColor = header.color || '#059669';
                  const isBlocLocked = blocCourses.length > 0 && blocCourses[0].locked;
                  const coursCourse = blocCourses.find(c => c.type === 'presentation' && !c.id.includes('etude'));
                  const quizCourse = blocCourses.find(c => c.type === 'quiz' && !c.id.includes('etude'));
                  const etudeCourse = blocCourses.find(c => c.type === 'presentation' && c.id.includes('etude'));
                  const quizEtudeCourse = blocCourses.find(c => c.type === 'quiz' && c.id.includes('etude'));
                  return (
                    <div key={blocId} data-testid={`tp-${blocId}-section`} style={{
                      marginBottom: '2rem', border: `2px solid ${isBlocLocked ? '#94A3B8' : blocColor}`,
                      borderRadius: '1rem', overflow: 'hidden', background: 'white',
                      opacity: isBlocLocked ? 0.6 : 1
                    }}>
                      {/* Bloc header with progression */}
                      <div style={{
                        background: isBlocLocked
                          ? 'linear-gradient(135deg, #64748B 0%, #94A3B8 100%)'
                          : `linear-gradient(135deg, ${blocColor} 0%, ${blocColor}CC 100%)`,
                        padding: '1.25rem 1.5rem', color: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                      }}>
                        <div style={{ flex: 1 }}>
                          <h3 style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.5rem' }}>
                            {isBlocLocked && <Lock size={18} style={{ display: 'inline', marginRight: '0.5rem', verticalAlign: 'middle' }} />}
                            {header.title}
                          </h3>
                          {!isBlocLocked && (() => {
                            const presProgress = coursCourse ? getActivityProgress(coursCourse.presentationType) : null;
                            const presPercent = presProgress && presProgress.totalSlides ? Math.round((presProgress.viewedSlides.length / presProgress.totalSlides) * 100) : 0;
                            const quizDone = false;
                            const etudeProgress = etudeCourse ? getActivityProgress(etudeCourse.presentationType) : null;
                            const etudePercent = etudeProgress && etudeProgress.totalSlides ? Math.round((etudeProgress.viewedSlides.length / etudeProgress.totalSlides) * 100) : 0;
                            const globalPercent = Math.round((presPercent * 0.5 + (quizDone ? 100 : 0) * 0.25 + etudePercent * 0.25));
                            return (
                              <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', opacity: 0.9, marginBottom: '0.25rem' }}>
                                  <span>Progression : {globalPercent}%</span>
                                  <span>Cours : {presPercent}% | Quiz : {quizDone ? 'Validé' : 'À faire'} | Étude : {etudePercent}%</span>
                                </div>
                                <div style={{ height: '6px', background: 'rgba(255,255,255,0.3)', borderRadius: '3px', overflow: 'hidden' }}>
                                  <div style={{ height: '100%', width: `${globalPercent}%`, background: 'white', borderRadius: '3px', transition: 'width 0.5s ease' }} />
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                        {isBlocLocked && (
                          <div style={{
                            background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem',
                            padding: '0.4rem 0.8rem', fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'nowrap', marginLeft: '1rem'
                          }}>
                            Terminez le bloc précédent
                          </div>
                        )}
                      </div>

                      {/* Course + Quiz side by side */}
                      <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                        {coursCourse && (
                          <div className="card hover-lift" data-testid={`tp-course-${blocId}`} style={{
                            cursor: isBlocLocked ? 'not-allowed' : 'pointer', margin: 0,
                            borderLeft: `3px solid ${isBlocLocked ? '#94A3B8' : blocColor}`, padding: '1.25rem'
                          }} onClick={() => handleCourseClick(coursCourse)}>
                            {coursCourse.thumbnail && <img src={coursCourse.thumbnail} alt={coursCourse.title} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem', filter: isBlocLocked ? 'grayscale(100%)' : 'none' }} />}
                            <div style={{ background: `${isBlocLocked ? '#94A3B8' : blocColor}20`, padding: '0.3rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                              <span className="caption font-mono" style={{ textTransform: 'uppercase', color: isBlocLocked ? '#94A3B8' : blocColor, fontWeight: '600' }}>PRÉSENTATION · {coursCourse.slideCount} SLIDES</span>
                            </div>
                            <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>{coursCourse.title}</h3>
                            <p className="body-small" style={{ color: '#666', lineHeight: '1.5' }}>{coursCourse.description}</p>
                          </div>
                        )}
                        {quizCourse && (
                          <div className="card hover-lift" data-testid={`tp-quiz-${blocId}`} style={{
                            cursor: isBlocLocked ? 'not-allowed' : 'pointer', margin: 0,
                            borderLeft: `3px solid ${isBlocLocked ? '#94A3B8' : '#E75480'}`, padding: '1.25rem'
                          }} onClick={() => handleCourseClick(quizCourse)}>
                            {quizCourse.thumbnail && <img src={quizCourse.thumbnail} alt={quizCourse.title} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem', filter: isBlocLocked ? 'grayscale(100%)' : 'none' }} />}
                            <div style={{ background: isBlocLocked ? '#94A3B820' : '#E7548020', padding: '0.3rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                              <span className="caption font-mono" style={{ textTransform: 'uppercase', color: isBlocLocked ? '#94A3B8' : '#E75480', fontWeight: '600' }}>QUIZ · {quizCourse.questionCount || 20} QUESTIONS</span>
                            </div>
                            <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>{quizCourse.title}</h3>
                            <p className="body-small" style={{ color: '#666', lineHeight: '1.5' }}>{quizCourse.description}</p>
                          </div>
                        )}
                      </div>

                      {/* Étude de cas */}
                      {(etudeCourse || quizEtudeCourse) && (
                        <div style={{ padding: '0 1.5rem 1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                          {etudeCourse && (
                            <div className="card hover-lift" data-testid={`tp-etude-${blocId}`} style={{
                              cursor: isBlocLocked ? 'not-allowed' : 'pointer', margin: 0,
                              borderLeft: `3px solid ${isBlocLocked ? '#94A3B8' : '#B45309'}`, padding: '1.25rem'
                            }} onClick={() => handleCourseClick(etudeCourse)}>
                              {etudeCourse.thumbnail && <img src={etudeCourse.thumbnail} alt={etudeCourse.title} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem', filter: isBlocLocked ? 'grayscale(100%)' : 'none' }} />}
                              <div style={{ background: isBlocLocked ? '#94A3B820' : '#B4530920', padding: '0.3rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                                <span className="caption font-mono" style={{ textTransform: 'uppercase', color: isBlocLocked ? '#94A3B8' : '#B45309', fontWeight: '600' }}>ÉTUDE DE CAS · {etudeCourse.slideCount} SLIDES</span>
                              </div>
                              <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>{etudeCourse.title}</h3>
                              <p className="body-small" style={{ color: '#666', lineHeight: '1.5' }}>{etudeCourse.description}</p>
                            </div>
                          )}
                          {quizEtudeCourse && (
                            <div className="card hover-lift" data-testid={`tp-quiz-etude-${blocId}`} style={{
                              cursor: isBlocLocked ? 'not-allowed' : 'pointer', margin: 0,
                              borderLeft: `3px solid ${isBlocLocked ? '#94A3B8' : '#9333EA'}`, padding: '1.25rem'
                            }} onClick={() => handleCourseClick(quizEtudeCourse)}>
                              {quizEtudeCourse.thumbnail && <img src={quizEtudeCourse.thumbnail} alt={quizEtudeCourse.title} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem', filter: isBlocLocked ? 'grayscale(100%)' : 'none' }} />}
                              <div style={{ background: isBlocLocked ? '#94A3B820' : '#9333EA20', padding: '0.3rem 0.75rem', borderRadius: '1rem', width: 'fit-content', marginBottom: '0.75rem' }}>
                                <span className="caption font-mono" style={{ textTransform: 'uppercase', color: isBlocLocked ? '#94A3B8' : '#9333EA', fontWeight: '600' }}>QUIZ ÉTUDE DE CAS · {quizEtudeCourse.questionCount || 10} QUESTIONS</span>
                              </div>
                              <h3 className="heading-3" style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>{quizEtudeCourse.title}</h3>
                              <p className="body-small" style={{ color: '#666', lineHeight: '1.5' }}>{quizEtudeCourse.description}</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            ) : selectedProgramId === 'caferuis' ? (
              /* CAFERUIS - 5 Blocs de compétences */
              <>
                {/* Introduction course */}
                {userCourses.filter(c => !c.isHeader && !c.blocId).map((course) => {
                  const courseProgress = getCourseProgress(course);
                  return (
                    <div key={course.id} className="card hover-lift" data-testid="caferuis-intro-course" style={{
                      cursor: 'pointer', marginBottom: '2rem',
                      background: 'linear-gradient(135deg, #1A365D 0%, #2B6CB0 100%)',
                      color: 'white', padding: '0', overflow: 'hidden', borderRadius: '1rem'
                    }} onClick={() => handleCourseClick(course)}>
                      {course.thumbnail && (
                        <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                      )}
                      <div style={{ padding: '1.5rem', display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{
                          background: 'rgba(255,255,255,0.2)', borderRadius: '1rem',
                          width: '60px', height: '60px',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                        }}>
                          <BookOpen size={32} color="white" />
                        </div>
                        <div style={{ flex: 1, minWidth: '200px' }}>
                          <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>{course.title}</h3>
                          <p style={{ opacity: 0.9, fontSize: '0.9rem' }}>{course.description}</p>
                        </div>
                        {courseProgress && (
                          <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem', padding: '0.5rem 1rem' }}>
                            <ProgressBadge progress={courseProgress} />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* 5 Bloc sections */}
                {['bc1', 'bc2', 'bc3', 'bc4', 'bc5'].map((blocId) => {
                  const header = userCourses.find(c => c.isHeader && c.blocId === blocId);
                  if (!header) return null;
                  const color = header.color || '#2B6CB0';
                  const blocCourses = userCourses.filter(c => !c.isHeader && c.blocId === blocId);
                  const isBlocLocked = blocCourses.length > 0 && blocCourses[0].locked;
                  return (
                    <div key={blocId} data-testid={`caferuis-${blocId}-section`} style={{
                      marginBottom: '2rem', border: `2px solid ${isBlocLocked ? '#94A3B8' : color}`,
                      borderRadius: '1rem', overflow: 'hidden', background: 'white',
                      opacity: isBlocLocked ? 0.6 : 1,
                      position: 'relative'
                    }}>
                      <div style={{
                        background: isBlocLocked
                          ? 'linear-gradient(135deg, #64748B 0%, #94A3B8 100%)'
                          : `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
                        padding: '1.25rem 1.5rem', color: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                      }}>
                        <div>
                          <h3 style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.5rem' }}>
                            {isBlocLocked && <Lock size={18} style={{ display: 'inline', marginRight: '0.5rem', verticalAlign: 'middle' }} />}
                            {header.title}
                          </h3>
                          <p style={{ fontSize: '0.9rem', opacity: 0.85 }}>{header.description}</p>
                        </div>
                        {isBlocLocked && (
                          <div style={{
                            background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem',
                            padding: '0.4rem 0.8rem', fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'nowrap'
                          }}>
                            Terminez le bloc précédent
                          </div>
                        )}
                      </div>
                      {blocCourses.length > 0 ? (
                        <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                          {blocCourses.map((course) => (
                            <div key={course.id} className="card hover-lift" style={{
                              cursor: course.locked ? 'not-allowed' : 'pointer',
                              margin: 0, borderLeft: `3px solid ${course.locked ? '#94A3B8' : color}`,
                              padding: '1.25rem', opacity: course.locked ? 0.7 : 1
                            }} onClick={() => handleCourseClick(course)}>
                              {course.thumbnail && <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '0.75rem', marginBottom: '1rem', filter: course.locked ? 'grayscale(100%)' : 'none' }} />}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                {course.locked && <Lock size={16} color="#94A3B8" />}
                                <h3 className="heading-3" style={{ fontSize: '1rem', color: course.locked ? '#94A3B8' : undefined }}>{course.title}</h3>
                              </div>
                              <p className="body-small" style={{ color: '#666', lineHeight: '1.5' }}>{course.description}</p>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ padding: '2rem', textAlign: 'center', color: '#9CA3AF' }}>
                          <FileText size={32} style={{ margin: '0 auto 0.75rem', opacity: 0.5 }} />
                          <p style={{ fontWeight: '500', fontSize: '0.95rem' }}>Contenu en cours de construction</p>
                          <p style={{ fontSize: '0.85rem', marginTop: '0.25rem' }}>Les cours de ce bloc seront disponibles prochainement</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              /* Default display for other programs */
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                {userCourses.filter(c => !c.isHeader).map((course) => (
                  <div
                    key={course.id}
                    className={`card hover-lift`}
                    style={{ 
                      cursor: course.locked ? 'not-allowed' : 'pointer',
                      opacity: course.locked ? 0.6 : 1,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                    onClick={() => handleCourseClick(course)}
                  >
                    {course.thumbnail && (
                      <img
                        src={course.thumbnail}
                        alt={course.title}
                        style={{
                          width: '100%',
                          height: '150px',
                          objectFit: 'cover',
                          borderRadius: '0.5rem',
                          marginBottom: '1rem'
                        }}
                      />
                    )}
                    <div style={{
                      background: course.locked ? 'var(--bg-section)' : 'var(--accent-blue-200)',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '1rem',
                      width: 'fit-content',
                      marginBottom: '0.75rem'
                    }}>
                      <span className="caption font-mono" style={{ textTransform: 'uppercase' }}>
                        {course.type}
                      </span>
                    </div>
                    <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>
                      {course.title}
                    </h3>
                    <p className="body-small" style={{ marginBottom: '1rem', flex: 1 }}>
                      {course.description}
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      {course.locked && <Lock size={16} />}
                      {course.completed && <CheckCircle size={16} style={{ color: 'green' }} />}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
            )}
          </div>

  );
};

export default CoursesTab;
